import AudioPlayer from '@/components/common/media-content/audio-player';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';

export default function ContentAudio({ message }: ContentCommonProps) {
  return (
    <div className='chat-bubble min-w-min group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary'>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1 w-full'
          quote={message.Quote}
        />
      )}

      <AudioPlayer
        src={message.Message}
        className='px-4 py-1.5'
      />
    </div>
  );
}
